import { render, staticRenderFns } from "./helpOrder.vue?vue&type=template&id=154e9dbe&scoped=true&"
import script from "./helpOrder.vue?vue&type=script&lang=js&"
export * from "./helpOrder.vue?vue&type=script&lang=js&"
import style0 from "./helpOrder.vue?vue&type=style&index=0&id=154e9dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e9dbe",
  null
  
)

export default component.exports